import type { FC, PropsWithChildren } from 'react'

import { monitoringSelector, useStore } from '@liveHelper/models/store'

import { RrwebClientProvider } from '@core/rrweb'

/** Provider component that loads the rrweb library when needed. */
export const MonitoringProvider: FC<PropsWithChildren> = ({ children }) => {
  const isMonitoring = useStore(monitoringSelector)

  return (
    <RrwebClientProvider loadClient={isMonitoring}>
      {children}
    </RrwebClientProvider>
  )
}
